import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Redirect from './pages/Redirect';
import Sweeps from './pages/Sweeps';
import AbCasinoSports from './pages/AbCasinoSports';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/redirect" element={<Redirect />} />
        <Route path="/sweeps" element={<Sweeps />} />
        <Route path="/alberta-casino-sports" element={<AbCasinoSports />} />
      </Routes>
    </Router>
  );
}

export default App;

